<mat-checkbox [formControl]="formControl"
              [disabled]="disabled"
              [labelPosition]="labelPosition"
              [attr.data-qa]="qaAttr"
              [attr.data-element]="'qa-element-checkbox'"
              (click)="$event.stopPropagation()"
              (change)="onMatCheckboxChange($event)">
  {{label}}
</mat-checkbox>